import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getEmpresaVisitas`, method: 'GET', body: null, token: token})
}